export default __webpack_public_path__ + "static/media/sleuthofbears.d2382d36.png";